import DropDown from 'components/BoxFieldset/DropDown.react';
import types from 'components/BoxFieldset/Constants';
import CategoryList from 'components/CategoryList/CategoryList.react';
import DashboardView from 'dashboard/DashboardView.react';
import EmptyState from 'components/EmptyState/EmptyState.react';
import LogView from 'components/LogView/LogView.react';
import LogViewEntry from 'components/LogView/LogViewEntry.react';
import React from 'react';
import history from 'dashboard/history';
import ReleaseInfo from 'components/ReleaseInfo/ReleaseInfo';
import Toolbar from 'components/Toolbar/Toolbar.react';
import LoaderContainer from 'components/LoaderContainer/LoaderContainer.react';

import styles from 'dashboard/Data/Logs/Logs.scss';

const subsections = {
  all: 'All',
  info: 'Info',
  warn: 'Warning',
  error: 'Error',
};

export default class Logs extends DashboardView {
  constructor() {
    super();
    this.section = 'Core';
    this.subsection = 'Logs';

    this.state = {
      logs: undefined,
      // release: undefined
    };
  }

  componentDidMount() {
    if (this.props.params.type) {
      this.fetchLogs(this.context.currentApp, this.props.params.type);
    } else {
      history.replace(`${this.props.location.pathname}/all`);
    }
    // this.fetchRelease(this.context.currentApp);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.context !== nextContext) {
      this.fetchLogs(nextContext.currentApp, nextProps.params.type);
      // this.fetchRelease(nextContext.currentApp);
    }
  }

  fetchLogs(app, type) {
    const typeParam = (type || 'INFO').toUpperCase();
    app.getLogs(typeParam).then(
      logs => this.setState({ logs }),
      () => this.setState({ logs: [] }),
    );
  }

  // fetchRelease(app) {
  //   app.getLatestRelease().then(
  //     ({ release }) => this.setState({ release }),
  //     () => this.setState({ release: null })
  //   );
  // }

  renderSidebar() {
    const current = this.props.params.type || '';
    return (
      <CategoryList
        current={current}
        linkPrefix="logs/"
        categories={[
        { name: 'All', id: 'all' },
        { name: 'Info', id: 'info' },
        { name: 'Warning', id: 'warn' },
        { name: 'Error', id: 'error' },
      ]} />
    );
  }

  renderContent() {
    let toolbar = null;
    if (subsections[this.props.params.type]) {
      toolbar = (
        <Toolbar
          section="Logs"
          subsection={subsections[this.props.params.type]}
          details={ReleaseInfo({ app: this.context.currentApp })}>
          <DropDown items={types.apps__logs} type="toolbar" />
        </Toolbar>
      );
    }
    let content = null;
    if (this.state.logs === undefined) {
      // loading
    } else if (this.state.logs.length === 0) {
      content = (
        <div className={styles.empty}>
          <EmptyState
            icon="files-outline"
            title="No logs in the last 30 days"
            description="When you start using Cloud Code, your logs will show up here."
            cta="Learn more"
            action={() => window.location = 'http://docs.parseplatform.org/cloudcode/guide/'} />
        </div>
      );
    } else {
      let i = 0;
      content = (
        <div className={styles.holder}>
          <LogView withCursor>
            {this.state.logs.map(({
              level, message, timestamp, meta,
            }) =>
              (<LogViewEntry
                key={`log-entry-${i++}`}
                text={message}
                level={level}
                timestamp={timestamp}
                meta={meta} />),
            )}
          </LogView>
        </div>
      );
    }
    return (
      <div className={styles.settings_page}>
        {toolbar}
        <div className={styles.logs}>
          <LoaderContainer close inner>
            {content}
          </LoaderContainer>
        </div>
      </div>
    );
  }
}
